var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.16406C7.02646 2.16406 2.16663 7.0239 2.16663 12.9974C2.16663 18.9709 7.02646 23.8307 13 23.8307C18.9735 23.8307 23.8333 18.9709 23.8333 12.9974C23.8333 7.0239 18.9735 2.16406 13 2.16406ZM13.7691 18.0999C13.3575 18.5007 12.6425 18.5007 12.2308 18.0999C12.0347 17.8941 11.9166 17.6124 11.9166 17.3307C11.9166 17.0491 12.0347 16.7674 12.2308 16.5616C12.4366 16.3666 12.7183 16.2474 13 16.2474C13.2816 16.2474 13.5633 16.3666 13.7691 16.5616C13.9641 16.7674 14.0833 17.0491 14.0833 17.3307C14.0833 17.6124 13.9641 17.8941 13.7691 18.0999ZM14.0833 14.0807C14.0833 14.6787 13.599 15.1641 13 15.1641C12.4009 15.1641 11.9166 14.6787 11.9166 14.0807V8.66406C11.9166 8.06606 12.4009 7.58073 13 7.58073C13.599 7.58073 14.0833 8.06606 14.0833 8.66406V14.0807Z",
    fill: "#F02828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFilled);
export default __webpack_public_path__ + "static/media/error-filled.ae745078bca9199a41893b6ca5b38f8a.svg";
export { ForwardRef as ReactComponent };